import { oc } from '@orpc/contract';
import { boardBindingSchema, updateBoardBindingInputSchema } from '../schemas/board.schemas.js';
export const updateBoardBindingContract = oc
    .route({
    method: 'PUT',
    path: '/board/bindings/{key}',
    tags: ['Board'],
    summary: 'Bind a metric key to a KPI (or unbind with kpiId null); 400 naming expected vs actual unit/currency on a mismatch (ADMIN, PM)',
})
    .input(updateBoardBindingInputSchema)
    .output(boardBindingSchema);
//# sourceMappingURL=update-board-binding.contract.js.map